// extracted by mini-css-extract-plugin
export var active = "Pagination-module--active--492b0";
export var bullet = "Pagination-module--bullet--94b62";
export var container = "Pagination-module--container--b54c4";
export var edge = "Pagination-module--edge--88ff6";
export var main = "Pagination-module--main--e5416";
export var pagination = "Pagination-module--pagination--0b873";